import { NgIf, NgClass } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';

// Define the StatusMapping interface
interface StatusMapping {
  status: string;
  cssClass: string;
}

@Component({
    selector: 'app-air-removed-save-tab',
    imports: [TableModule, DropdownModule, FormsModule, NgIf, NgClass],
    templateUrl: './air-removed-save-tab.component.html',
    styleUrl: './air-removed-save-tab.component.scss'
})
export class AirRemovedSaveTabComponent implements  OnChanges {
 
   @Input() airAPIData: any = '';
   removedData: any[] = [];
   originalRemovedData: any[] = [];
   
   // Loading state for API calls
   loading: boolean = false;
 
   constructor(private router: Router) {
   }
 
   ngOnChanges(changes: SimpleChanges): void {
     // This lifecycle hook is called whenever an input property changes
     if (changes['airAPIData']) {
       if (this.airAPIData) {
         this.processAirData();
       }
     }
   }
 
   /**
    * Processes the received API data for both table and dropdown
    */
   private processAirData(): void {
     
     // Process table data
     if (this.airAPIData && 
         this.airAPIData.airOverviewData && 
         this.airAPIData.airOverviewData.airAssignedToMeData && 
         this.airAPIData.airOverviewData.airAssignedToMeData.AIRAssignedToMeRemoved) {
       
       const tableData = this.airAPIData.airOverviewData.airAssignedToMeData.AIRAssignedToMeRemoved;
       
       if (Array.isArray(tableData)) {
         this.originalRemovedData = tableData;
         this.processTableData(tableData);
       }
     }
   }
 
    
   /**
    * Maps a TLR status code to a user-friendly status label and CSS class
    * @param statusCode The TLR status code (I, P, R, etc.)
    * @returns Object containing the formatted status and CSS class
    */
   mapStatusAndCssClass(statusCode: string): StatusMapping {
     const statusCode2 = statusCode || '';
     let status = '';
     let cssClass = '';
     
     if (statusCode2 === 'I') {
       status = 'Installed';
       cssClass = 'green';
     } else if (statusCode2 === 'P') {
       status = 'Pre Installation';
       cssClass = 'blue';
     } else if (statusCode2 === 'R') {
       status = 'Removed';
       cssClass = 'red';
     } else {
       // Default case
       status = statusCode2;
       cssClass = '';
     }
     
     return { status, cssClass };
   }
   
   
   // Process the table data from API response
   processTableData(data: any[]): void {
     
     if (Array.isArray(data) && data.length > 0) {
       // Map API data to the format needed for the table
       this.originalRemovedData = data;
       this.removedData = data.map((item: any) => {
         // Convert tlr_status values to user-friendly text
         const { status, cssClass } = this.mapStatusAndCssClass(item.tlr_status);
 
         return {
           division: item.division_name || '',
           section: item.section_name || '',
           tlr: item.tag_number || '',
           status: status,
           cssClass: cssClass // Add CSS class for styling
         };
       });
       
     } else {
       console.warn('Unable to process table data: data is empty or not an array');
     }
   }
   
   
   details(row: any){
     this.router.navigate(['/details-section', row.tlr]);
   }
 }
 
 